import * as React from 'react';
import { FormDataBuilder, makeFormControls, validateForm } from '../formElements/util';
import { isEmail, isEmpty, isTable } from '../formElements/validators';
import Form from '../formElements/Form';
import Modal from '../modal/Modal';
import { api } from '../../environment';
import { Link } from 'react-router-dom';
import {isBrowser, isMobile } from 'react-device-detect';

export default function ReviewForm({formData, formControls, setFormControls, activity_id, hash, links}){
    const [modalHidden, setModalHidden] = React.useState(true);

  
   
    
    const extractData = (formControls)=>{
        let data = {}
        for(let c in formControls){
            data[c] = formControls[c].value
        }
	console.log('DATA', data);
        return data
    }

    const sendFormData = () => {
        let review_data = extractData(formControls)
	review_data['activity_id'] = activity_id;
	review_data['hash'] = hash;

        let call = fetch(api+"/update_review",{
            method: "POST",
            body:JSON.stringify(
                {review:review_data})
        })


            try{
        return call.then(response=>response.json())
            } catch(err){
                console.log(err);
                return {}
            }
    }

    const submitForm = () =>{
        let validity = validateForm(formData, formControls, setFormControls);


        if(validity){
            setModalHidden(false);
            sendFormData().then((response)=>{
                console.log(response)
            })
        }

    }



    return (
        <>
	    <Form formControls={formControls} setFormControls={setFormControls} formData={formData} />
	    {
		links.map((link, index)=>{
		    return (<Link key={index} to={link.link}>
				{link.text}
			    </Link>)
		})
	    }
	    
            <div className="tool-tray"><button onClick={submitForm} className='pillbox'>Ažurirati</button></div>
         <Modal hidden={modalHidden} title="Recenzija je ažurirana." content={<div></div>}
            buttons={[<button className="modal-button" onClick={()=>{																					
                setModalHidden(true);																									
            }}>U redu</button>]}/>																									

        </>
    )

}



